const GTAG_MARKETS_ENABLED = ['en-au', 'en-ca', 'fr-ca', 'es-mx', 'ja-jp', 'en-gb', 'en-hk', 'zh-hk'];

export const loadGtagScript = (locale) => !!GTAG_MARKETS_ENABLED.includes(locale?.toLowerCase());
